/* eslint-disable no-console */
import { Directive, Input, isDevMode, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldDescriptor } from '@nimbus-global/features/permissions/models/field-descriptor.model';
import { getIcuParameters } from '@nimbus-library/features/localization/utils/utils';

@Directive({
  standalone: true,
  selector: '[nimbusPermissionsFieldDescriptorAssert]',
})
export class InputPermissionsFieldDescriptorAssertDirective implements OnInit {
  @Input() public nimbusPermissionsFieldDescriptorAssert: FieldDescriptor;
  @Input() public inputPermissions: string[];
  @Input() public sectionLabel: string;
  @Input() public label: string;
  @Input() public columnName: string;

  public constructor(private readonly translateService: TranslateService) {}

  public ngOnInit(): void {
    if (!!this.inputPermissions?.length) {
      this.validatePermission();
    }
    const label = this.label || this.sectionLabel || this.columnName;
    if (label) {
      this.validateLabel(label);
    }
  }

  public validatePermission(): void {
    const permissionKeys = this.inputPermissions.map((permission) => permission.split(':')[0]);
    if (isDevMode() && !permissionKeys.includes(this.nimbusPermissionsFieldDescriptorAssert.permissionKey)) {
      console.error(
        `The permission key "${this.nimbusPermissionsFieldDescriptorAssert.permissionKey}" is not included in the input permissions: ${JSON.stringify(this.inputPermissions)} for field with label "${this.label || this.sectionLabel}"`,
      );
    }
  }

  public validateLabel(label: string): void {
    const expectedLabel = this.translateService.instant(
      this.nimbusPermissionsFieldDescriptorAssert.translationInfo.translationKey,
      getIcuParameters(
        this.nimbusPermissionsFieldDescriptorAssert.translationInfo.translationKey,
        this.nimbusPermissionsFieldDescriptorAssert.translationInfo.pluralForm,
      ),
    );
    if (isDevMode() && expectedLabel !== label) {
      console.error(`The label "${label}" does not match the expected translation for key "${expectedLabel}"`);
    }
  }
}
